import { IDropDownMaquinaEquipUseCase } from "../../../presentation/useCases/read/drop_down_maquina_equip_use_case";
import { MaquinaEquipDropdown } from "../../models/maquina_equip_dropdown";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DropDownMaquinaEquipUseCase
 */

export class DropDownMaquinaEquipUseCase implements IDropDownMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async dropDownMaquinaEquip(
  ): Promise<MaquinaEquipDropdown[]> {
    return await this.repository.dropDownMaquinaEquip();
  }
}
